// import axios from "axios";

// const apiService = axios.create({
//   baseURL: "https://esystems.cdl.lk/backend/AttendMe2/attme/",
//   //baseURL: "http://172.30.30.96:2500/attme/",
//   headers: {
//     UserId: "DTSUSER",
//     Password: "Rayan@123",
//   },
// });



// export default apiService;








import axios from "axios";

const apiService = {
  getJob: (date, serviceNo, location) =>
    axios.get(
      `attme/GetGroupAttendance?date=${date}&serviceNo=${serviceNo}&location=${location}`,
      {
        headers: {
          UserId: "DTSUSER",
          Password: "Rayan@123",
        },
      }
    ),
};

export default apiService;

